import firebase from 'firebase';

// eslint-disable-next-line
export function getAuth() {
  const auth = firebase.auth().currentUser;

  return auth ? Promise.resolve(auth) : new Promise((resolve) => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });
}



// WEBPACK FOOTER //
// ./src/firebase/repositories/auth.js